import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {    
    width: '12px',
    height: '11px',
    viewBox: '0px 0px 12px 11px',
    fill:'none',
    stroke: '#C4C4C4'   
  },  
})

export default styleOverride
